import { lazy } from 'react';

const CleaningSessionsPage = lazy(() => import('./CleaningSessionsPage'));

/**
 * The Cleaning Sessions page config.
 */
const CleaningSessionsConfig = {
    settings: {
        layout: {}
    },
    auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner'],
    routes: [
        {
            path: 'cleaning-sessions',
            element: <CleaningSessionsPage />
        }
    ]
};

export default CleaningSessionsConfig; 